import { FIELD_ALIASES } from "./constants";

// name of the real column when a field is read through an alias, else null
export function getFieldAlias(stage, field) {
  const data = stage.data || {};
  if (field in data) return null;
  const alias = FIELD_ALIASES[stage.stageLabel]?.[field];
  return alias && alias in data ? alias : null;
}

// Ref ID of a stage row (the collections table stores it in `id`)
export function getRefId(stage) {
  const data = stage.data || {};
  return data.refid ?? (stage.stageLabel === "collections" ? data.id : undefined);
}

// Clean MD5 of a stage row: cleanmd5, else txtmd5 (first one that has a value)
export function getMd5(stage) {
  for (const field of ["cleanmd5", "txtmd5"]) {
    const v = getFieldValue(stage, field);
    if (v !== undefined && v !== null && v !== "") return v;
  }
  return undefined;
}

// value of a field for one stage (own column first, then its alias)
export function getFieldValue(stage, field) {
  const data = stage.data || {};
  if (field in data) return data[field];
  const alias = getFieldAlias(stage, field);
  return alias ? data[alias] : undefined;
}